import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Marks a single notification as read.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param id - Notification id.
 * @returns OperationResult (no payload).
 */
export const readNotification = async (instance: KyInstance, id: number): Promise<OperationResult> => {
  try {
    return await instance.patch<OperationResult>(formatString(Uri.notifications.readById, String(id))).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
